import { useEffect } from "react";
import { gsap } from "gsap";

const MAX_STARS = 10;

const ShootingStars = () => {
  useEffect(() => {
    const activeStars = new Set();

    const createShootingStar = () => {
      // Skip if max stars reached
      if (activeStars.size >= MAX_STARS) return;

      const star = document.createElement("div");
      star.className = "shooting-star";

      const topStart = Math.random() < 0.7;

      if (topStart) {
        star.style.top = `${Math.random() * 20}vh`;
        star.style.right = `${Math.random() * 80}vw`;
      } else {
        star.style.top = `${Math.random() * 60}vh`;
        star.style.right = `0`;
      }

      document.body.appendChild(star);
      activeStars.add(star);

      gsap.fromTo(
        star,
        {
          x: 0,
          y: 0,
          opacity: 1,
        },
        {
          x: -800,
          y: 800,
          opacity: 0,
          duration: 5.5,
          ease: "power1.out",
          onComplete: () => {
            star.remove();
            activeStars.delete(star);
          },
        }
      );
    };

    const interval = setInterval(() => {
      if (Math.random() > 0.5) createShootingStar();
    }, 3000);

    return () => {
      clearInterval(interval);
      // Cleanup any remaining stars
      activeStars.forEach((star) => star.remove());
      activeStars.clear();
    };
  }, []);

  return null;
};

export default ShootingStars;
